export const encrypt = (string)=>{
    let encrypted_word = ''
    if(typeof string == "string" ){
        for(let i=0;i<string.length;i++){
             const isCapitalLetter = string[i].toUpperCase() === string[i] ? true : false
             const letter = isCapitalLetter ? string[i].toLowerCase() : string[i];
             const encrypt_letter = (index,store) => isCapitalLetter ? store[index].toUpperCase() : store[index]; 
             const _minor1= ['a','b','c','d','e','f','g','h','i','j','k','l','m'];   
             const _minor2= ['n','o','p','q','r','s','t','u','v','w','x','y','z'];
                if(_minor1.includes(letter)){
                     encrypted_word += encrypt_letter(_minor1.indexOf(letter),_minor2)
                }else if(_minor2.includes(letter)){
                    encrypted_word += encrypt_letter(_minor2.indexOf(letter),_minor1)
                }else{
                    encrypted_word += string[i]
                }
         }
        return encrypted_word
    }
    return('invalid parameter')
   
}

export const de_encrypt = (string)=>{
    let de_encrypted_word = ''
    if(typeof string == "string" ){
        for(let i=0;i<string.length;i++){
             const isCapitalLetter = string[i].toUpperCase() === string[i] ? true : false
             const letter = isCapitalLetter ? string[i].toLowerCase() : string[i];
             const encrypt_letter = (index,store) => isCapitalLetter ? store[index].toUpperCase() : store[index]; 
             const _minor1= ['a','b','c','d','e','f','g','h','i','j','k','l','m'];   
             const _minor2= ['n','o','p','q','r','s','t','u','v','w','x','y','z'];
                if(_minor1.includes(letter)){
                     de_encrypted_word += encrypt_letter(_minor1.indexOf(letter),_minor2)
                }else if(_minor2.includes(letter)){
                    de_encrypted_word += encrypt_letter(_minor2.indexOf(letter),_minor1)
                }else{
                    de_encrypted_word += string[i]
                }
         }
        return de_encrypted_word
    }
    return('invalid parameter')
   
}